import { useEffect, useRef, useState } from "react";

import { fetchSlideImage, type SlideImage } from "../bridge/slideImage.ts";

export function SlideChip({ label, slide }: { label: string; slide: number }) {
  const [open, setOpen] = useState(false);
  const [img, setImg] = useState<SlideImage | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const hoverTimer = useRef<number | null>(null);

  useEffect(() => {
    if (!open || img || err) return;
    let cancelled = false;
    fetchSlideImage(slide, { width: 320 }).then(
      (c) => {
        if (!cancelled) setImg(c);
      },
      (e: unknown) => {
        if (!cancelled) setErr(e instanceof Error ? e.message : String(e));
      },
    );
    return () => {
      cancelled = true;
    };
  }, [open, slide, img, err]);

  const onEnter = () => {
    if (hoverTimer.current !== null) window.clearTimeout(hoverTimer.current);
    hoverTimer.current = window.setTimeout(() => {
      setOpen(true);
    }, 120);
  };
  const onLeave = () => {
    if (hoverTimer.current !== null) window.clearTimeout(hoverTimer.current);
    hoverTimer.current = window.setTimeout(() => {
      setOpen(false);
    }, 80);
  };

  return (
    <span className="relative inline-block" onMouseEnter={onEnter} onMouseLeave={onLeave}>
      <span className="cursor-help rounded bg-[var(--color-primary)]/10 px-1 py-0.5 text-[var(--color-primary)] underline decoration-dotted underline-offset-2">
        {label}
      </span>
      {open && (
        <span className="absolute left-0 top-full z-30 mt-1 block w-56 rounded-md border border-[var(--color-border)] bg-[var(--color-card)] p-1 shadow-lg">
          {img ? (
            <img
              src={`data:${img.mediaType};base64,${img.base64}`}
              alt={`Slide ${String(slide + 1)}`}
              className="block h-auto w-full rounded-sm"
            />
          ) : err ? (
            <span className="block px-2 py-3 text-[10px] text-[var(--color-muted-foreground)]">
              Preview unavailable
            </span>
          ) : (
            <span className="block px-2 py-3 text-[10px] text-[var(--color-muted-foreground)]">
              Loading…
            </span>
          )}
        </span>
      )}
    </span>
  );
}
